declare const I18n;

import * as React from "react";
import { UberTable, RowDefinition } from "./UberTable";
import { Learner } from "../../types";

type Props = {
  isFacilitator: boolean;
};


class LearnersTable extends React.Component<Props<Learner>> {
  private rowDefinition: RowDefinition<Learner>[];

  constructor(props: Props<Learner>) {
    super(props);

    const { isFacilitator } = props;

    this.rowDefinition = [
      {
        title: I18n.t("models.common.name"),
        attribute_key: "name",
        sort_key: "name",
        render: (learner: Learner) => {
          return !learner.is_deleted ? (
            <a href={learner.edit_url}>{learner.name}</a>
          ) : (
            learner.name
          );
        },
      },
      {
        title: I18n.t("models.learner.messaging.guardian_information"),
        attribute_key: "guardian_name",
        render: (learner: Learner) => {
          if (!learner.guardian_name) return "-";

          const name = !learner.is_deleted && learner.guardian_edit_url ? (
            <a href={learner.guardian_edit_url}>{learner.guardian_name}</a>
          ) : (
            learner.guardian_name
          );

          return (
            <>
              <div>{name}</div>
              {learner.guardian_email ? (
                <div className="small text-black">{learner.guardian_email}</div>
              ) : null}
            </>
          );
        },
      },
      {
        title: I18n.t("models.learner.attributes.pronouns"),
        attribute_key: "pronouns",
        sort_key: "pronouns",
        render: (learner: Learner) => {
          return learner.pronouns ? learner.pronouns : "-";
        },
      },
      {
        title: I18n.t("models.learner.attributes.experience_level"),
        attribute_key: "experience_level",
        sort_key: "experience_level",
        render: (learner: Learner) => {
          return learner.experience_level ? learner.experience_level : "-";
        },
      },
      {
        title: I18n.t("models.resource.attributes.level"),
        attribute_key: "level",
        sort_key: "level",
      },

      ...(!isFacilitator
        ? [
          {
            title: I18n.t("models.learner.attributes.current_organization"),
            attribute_key: "organization_name",
            render: (learner: Learner) => {
              return learner.organization_name ? learner.organization_name : "N/A";
            },
          },
        ]
        : []),
      {
        title: "Courses",
        attribute_key: "view_course_progress",
        textAlignment: "center",
        render: (learner: Learner) => {
          return (
            <a
              href={`/learners/${learner.id}/courses`}
              className="btn btn-link pt-0"
            >
              {I18n.t("models.course.messaging.view_all_courses")}
            </a>
          );
        },
      },
      {
        title: I18n.t("models.learner.attributes.last_seen_at"),
        attribute_key: "last_seen_at",
        sort_key: "last_seen_at_sortable",
        render: (learner: Learner) => learner.last_seen_at ?? "Never",
      },
      {
        title: I18n.t("models.common.status"),
        attribute_key: "active",
        sort_key: "active",
        render: (learner: Learner) => {
          return learner.is_active ? (
            <span className="badge badge-wide badge-success">
              {I18n.t("views.common.active")}
            </span>
          ) : (
            <span className="badge badge-warning">
              {I18n.t("views.common.pending")}
            </span>
          );
        },
      },
    ];
  }

  render() {
    return (
      <UberTable<Learner>
        rowDefinition={this.rowDefinition}
        searchType="learner"
        {...this.props}
      />
    );
  }
}

export default LearnersTable;
